const topicSlugs = {
    activities_general: "Sports And Activities",
    ambiance_general: "Ambiance",
    amenities: "Amenities",
    atmosphere_general: "Ambiance",
    bathroom: "Bathroom",
    bathroom_general: "Bathroom",
    bed: "Bed",
    breakfast: "Breakfast",
    checkin_process: "Checkin Process",
    cleanliness: "Cleanliness",
    cleanliness_general: "Cleanliness",
    comfort: "Comfort",
    comfort_general: "Comfort",
    condition: "Condition",
    cultural_activities: "Sports And Activities",
    decoration: "Decoration",
    decoration_general: "Decoration",
    drinks_quality: "Hotel Drinks Quality",
    entertainment: "Entertainment",
    entertainment_general: "Entertainment",
    facilities_general: "Facilities",
    facilities_meeting: "Meeting",
    facilities_wifi: "Amenities",
    family_friendliness: "Family Friendliness",
    food: "Food",
    food_atmosphere: "Ambiance",
    food_cleanliness: "Food Cleanliness",
    food_general: "Food",
    food_quality: "Food Quality",
    food_variety: "Food",
    general: "General",
    helpfulness: "Helpfulness",
    hospitality: "Hospitality",
    hotel: "Hotel",
    hotel_accessibility: "Accessibility",
    hotel_drinks_quality: "Hotel Drinks Quality",
    hotel_food_quality: "Hotel Food Quality",
    hotel_general: "Hotel",
    hotel_sustainability: "Condition",
    hotel_terrace: "Ambiance",
    location: "Location",
    location_activities: "Sports And Activities",
    location_beach: "Location",
    location_food: "Food",
    location_general: "Location",
    location_nightlife: "Entertainment",
    location_noise: "Condition",
    location_shopping: "Shopping",
    location_sightseeing: "Location",
    location_skiing: "Sports",
    location_traffic: "Condition",
    meeting: "Meeting",
    overall: "General",
    overall_general: "General",
    overall_stay: "Overall Stay",
    pool: "Pool",
    property_condition: "Property Condition",
    reception: "Reception",
    room: "Rooms",
    room_bathroom: "Bathroom",
    room_bed: "Bed",
    room_cleanliness: "Room Cleanliness",
    room_design: "Decoration",
    room_general: "Room (Overall)",
    room_size: "Size",
    rooms: "Rooms",
    service: "Service",
    service_competence: "Service",
    service_general: "Service",
    service_reception: "Reception",
    sleep: "Sleep",
    sleep_quality: "Sleep Quality",
    sport: "Sports",
    sport_beach: "Location",
    sport_children: "Family Friendliness",
    sport_general: "Sports",
    sport_offer: "Sports",
    sport_pool: "Swimming Pool",
    sports_and_activities: "Sports And Activities",
    staff: "Staff",
    staff_attention: "Staff Attention",
    staff_hospitality: "Hospitality",
    staff_service: "Staff Service",
    swimming_pool: "Swimming Pool",
    value: "Value",
    value_general: "Value",
    wellness: "Wellness",
    wellness_general: "Wellness"
};

const langs = {
    af: "Afrikaans",
    am: "አማርኛ (Amharic)",
    ar: "العربية (Arabic)",
    bg: "български език (Bulgarian)",
    cs: "český (Czech)",
    nl: "Nederlands (Dutch)",
    en: "English",
    tl: "Filipino",
    fr: "Français (French)",
    de: "Deutsch (German)",
    el: "Ελληνικά (Greek)",
    it: "Italiano (Italian)",
    pt: "Português (Portuguese)",
    es: "Español (Spanish)",
    sw: "Kiswahili (Swahili)",
    sv: "Svenska (Swedish)",
    th: "ภาษาไทย (Thai)",
    tr: "Türkçe (Turkish)",
    ro: "Română (Romanian)",
    ru: "русский (Russian)",
    uk: "Українська (Ukrainian)"
};

const sources = {
    facebook_pages: "Facebook",
    trip_advisor: "TripAdvisor",
    booking_com: "Booking.com",
    hotels_com: "Hotels.com",
    google: "Google",
    zoover: "Zoover",
    agoda: "Agoda",
    cheaptickets: "CheapTickets",
    ctrip: "CTrip",
    ebookers: "Ebookers.ie",
    expedia: "Expedia",
    goibibo: "Goibibo",
    holiday_check: "HolidayCheck",
    hotels_de: "Hotel.de",
    hrs: "HRS",
    orbitz: "Orbitz",
    priceline: "Priceline",
    travelocity: "Travelocity",
    venere: "Venere",
    wotif: "Wotif",
    lastminute: "lastminute.com",
    holiday_iq: "HolidayIQ",
    hotel_specials: "Hotelspecials.nl",
    weekendje_weg: "Weekendjeweg.nl",
    thefork: "thefork",
    hotels_nl: "Hotels.nl",
    hotelkamerveiling: "HotelKamerVeiling.nl",
    airbnb: "Airbnb",
    hoteliers_com: "Hoteliers.com",
    hotel_feedback: "HotelFeedback",
    exclusivi: "Exclusivi",
    top_hotels_ru: "TopHotels.ru",
    weg_de: "Weg.de",
    urlaub_de: "Ab-in-den-urlaub",
    tui_com: "Tui.com",
    check24_de: "Check24",
    atrapalo_com: "Atrapalo",
    yelp: "Yelp",
    voyage_prive: "Voyage Prive",
    itaka_pl: "Itaka.pl",
    travel_republic: "Travel Republic",
    corendon_nl: "Corendon.nl",
    foursquare: "FourSquare",
    opentable: "OpenTable",
    zomato: "Zomato",
    trustpilot: "Trustpilot",
    alpharooms: "Alpharooms",
    hotel_de: "Hotel.de",
    sunweb: "Sunweb",
    traveloka: "Traveloka",
    qunar: "Qunar",
    vrbo: "Vrbo",
    cruisecritic: "Cruise Critic",
    directbooking: "Direct Booking",
    halalbooking: "HalalBooking",
    tui_nl: "Tui.nl",
    otelpuan: "Otelpuan",
    cedok: "Cedok",
    iescape: "i-escape",
    google_play: "Google Play",
};

const ratingTypes = {
    expedia: 10 ,
    booking_com: 10,
    trip_advisor: 5,
    holiday_check: 6,
    exclusivi: 10,
    hotels_com: 10,
    yelp: 5,
    check24_de: 10,
    hostelworld: 10,
    atrapalo_com: 10,
    voyage_prive: 10,
};

const countryMap = {
    'af': __('Afghanistan'),
    'ax': __('Åland Islands'),
    'al': __('Albania'),
    'dz': __('Algeria'),
    'as': __('American Samoa'),
    'ad': __('Andorra'),
    'ao': __('Angola'),
    'ai': __('Anguilla'),
    'aq': __('Antarctica'),
    'ag': __('Antigua and Barbuda'),
    'ar': __('Argentina'),
    'am': __('Armenia'),
    'aw': __('Aruba'),
    'au': __('Australia'),
    'at': __('Austria'),
    'az': __('Azerbaijan'),
    'bs': __('Bahamas'),
    'bh': __('Bahrain'),
    'bd': __('Bangladesh'),
    'bb': __('Barbados'),
    'by': __('Belarus'),
    'be': __('Belgium'),
    'bz': __('Belize'),
    'bj': __('Benin'),
    'bm': __('Bermuda'),
    'bt': __('Bhutan'),
    'bo': __('Bolivia, Plurinational State of'),
    'ba': __('Bosnia and Herzegovina'),
    'bw': __('Botswana'),
    'bv': __('Bouvet Island'),
    'br': __('Brazil'),
    'io': __('British Indian Ocean Territory'),
    'bn': __('Brunei Darussalam'),
    'bg': __('Bulgaria'),
    'bf': __('Burkina Faso'),
    'bi': __('Burundi'),
    'kh': __('Cambodia'),
    'cm': __('Cameroon'),
    'ca': __('Canada'),
    'cv': __('Cape Verde'),
    'ky': __('Cayman Islands'),
    'cf': __('Central African Republic'),
    'td': __('Chad'),
    'cl': __('Chile'),
    'cn': __('China'),
    'cx': __('Christmas Island'),
    'cc': __('Cocos (Keeling) Islands'),
    'co': __('Colombia'),
    'km': __('Comoros'),
    'cg': __('Congo'),
    'cd': __('Congo, the Democratic Republic of the'),
    'ck': __('Cook Islands'),
    'cr': __('Costa Rica'),
    'ci': __("Côte d'Ivoire"),
    'hr': __('Croatia'),
    'cu': __('Cuba'),
    'cy': __('Cyprus'),
    'cz': __('Czech Republic'),
    'dk': __('Denmark'),
    'dj': __('Djibouti'),
    'dm': __('Dominica'),
    'do': __('Dominican Republic'),
    'ec': __('Ecuador'),
    'eg': __('Egypt'),
    'sv': __('El Salvador'),
    'gq': __('Equatorial Guinea'),
    'er': __('Eritrea'),
    'ee': __('Estonia'),
    'et': __('Ethiopia'),
    'fk': __('Falkland Islands (Malvinas)'),
    'fo': __('Faroe Islands'),
    'fj': __('Fiji'),
    'fi': __('Finland'),
    'fr': __('France'),
    'gf': __('French Guiana'),
    'pf': __('French Polynesia'),
    'tf': __('French Southern Territories'),
    'ga': __('Gabon'),
    'gm': __('Gambia'),
    'ge': __('Georgia'),
    'de': __('Germany'),
    'gh': __('Ghana'),
    'gi': __('Gibraltar'),
    'gr': __('Greece'),
    'gl': __('Greenland'),
    'gd': __('Grenada'),
    'gp': __('Guadeloupe'),
    'gu': __('Guam'),
    'gt': __('Guatemala'),
    'gg': __('Guernsey'),
    'gn': __('Guinea'),
    'gw': __('Guinea-Bissau'),
    'gy': __('Guyana'),
    'ht': __('Haiti'),
    'hm': __('Heard Island and McDonald Islands'),
    'va': __('Holy See (Vatican City State)'),
    'hn': __('Honduras'),
    'hk': __('Hong Kong'),
    'hu': __('Hungary'),
    'is': __('Iceland'),
    'in': __('India'),
    'id': __('Indonesia'),
    'ir': __('Iran, Islamic Republic of'),
    'iq': __('Iraq'),
    'ie': __('Ireland'),
    'im': __('Isle of Man'),
    'il': __('Israel'),
    'it': __('Italy'),
    'jm': __('Jamaica'),
    'jp': __('Japan'),
    'je': __('Jersey'),
    'jo': __('Jordan'),
    'kz': __('Kazakhstan'),
    'ke': __('Kenya'),
    'ki': __('Kiribati'),
    'kp': __("Korea, Democratic People's Republic of"),
    'kr': __('Korea, Republic of'),
    'kw': __('Kuwait'),
    'kg': __('Kyrgyzstan'),
    'la': __("Lao People's Democratic Republic"),
    'lv': __('Latvia'),
    'lb': __('Lebanon'),
    'ls': __('Lesotho'),
    'lr': __('Liberia'),
    'ly': __('Libyan Arab Jamahiriya'),
    'li': __('Liechtenstein'),
    'lt': __('Lithuania'),
    'lu': __('Luxembourg'),
    'mo': __('Macao'),
    'mk': __('Macedonia'),
    'mg': __('Madagascar'),
    'mw': __('Malawi'),
    'my': __('Malaysia'),
    'mv': __('Maldives'),
    'ml': __('Mali'),
    'mt': __('Malta'),
    'mh': __('Marshall Islands'),
    'mq': __('Martinique'),
    'mr': __('Mauritania'),
    'mu': __('Mauritius'),
    'yt': __('Mayotte'),
    'mx': __('Mexico'),
    'fm': __('Micronesia, Federated States of'),
    'md': __('Moldova, Republic of'),
    'mc': __('Monaco'),
    'mn': __('Mongolia'),
    'me': __('Montenegro'),
    'ms': __('Montserrat'),
    'ma': __('Morocco'),
    'mz': __('Mozambique'),
    'mm': __('Myanmar'),
    'na': __('Namibia'),
    'nr': __('Nauru'),
    'np': __('Nepal'),
    'nl': __('Netherlands'),
    'an': __('Netherlands Antilles'),
    'nc': __('New Caledonia'),
    'nz': __('New Zealand'),
    'ni': __('Nicaragua'),
    'ne': __('Niger'),
    'ng': __('Nigeria'),
    'nu': __('Niue'),
    'nf': __('Norfolk Island'),
    'mp': __('Northern Mariana Islands'),
    'no': __('Norway'),
    'om': __('Oman'),
    'pk': __('Pakistan'),
    'pw': __('Palau'),
    'ps': __('Palestinian Territory, Occupied'),
    'pa': __('Panama'),
    'pg': __('Papua New Guinea'),
    'py': __('Paraguay'),
    'pe': __('Peru'),
    'ph': __('Philippines'),
    'pn': __('Pitcairn'),
    'pl': __('Poland'),
    'pt': __('Portugal'),
    'pr': __('Puerto Rico'),
    'qa': __('Qatar'),
    're': __('Réunion'),
    'ro': __('Romania'),
    'ru': __('Russian Federation'),
    'rw': __('Rwanda'),
    'bl': __('Saint Barthélemy'),
    'sh': __('Saint Helena'),
    'kn': __('Saint Kitts and Nevis'),
    'lc': __('Saint Lucia'),
    'mf': __('Saint Martin (French part)'),
    'pm': __('Saint Pierre and Miquelon'),
    'vc': __('Saint Vincent and the Grenadines'),
    'ws': __('Samoa'),
    'sm': __('San Marino'),
    'st': __('Sao Tome and Principe'),
    'sa': __('Saudi Arabia'),
    'sn': __('Senegal'),
    'rs': __('Serbia'),
    'sc': __('Seychelles'),
    'sl': __('Sierra Leone'),
    'sg': __('Singapore'),
    'sk': __('Slovakia'),
    'si': __('Slovenia'),
    'sb': __('Solomon Islands'),
    'so': __('Somalia'),
    'za': __('South Africa'),
    'gs': __('South Georgia and the South Sandwich Islands'),
    'es': __('Spain'),
    'lk': __('Sri Lanka'),
    'sd': __('Sudan'),
    'sr': __('Suriname'),
    'sj': __('Svalbard and Jan Mayen'),
    'sz': __('Swaziland'),
    'se': __('Sweden'),
    'ch': __('Switzerland'),
    'sy': __('Syrian Arab Republic'),
    'tw': __('Taiwan, Province of China'),
    'tj': __('Tajikistan'),
    'tz': __('Tanzania, United Republic of'),
    'th': __('Thailand'),
    'tl': __('Timor-Leste'),
    'tg': __('Togo'),
    'tk': __('Tokelau'),
    'to': __('Tonga'),
    'tt': __('Trinidad and Tobago'),
    'tn': __('Tunisia'),
    'tr': __('Turkey'),
    'tm': __('Turkmenistan'),
    'tc': __('Turks and Caicos Islands'),
    'tv': __('Tuvalu'),
    'ug': __('Uganda'),
    'ua': __('Ukraine'),
    'ae': __('United Arab Emirates'),
    'gb': __('United Kingdom'),
    'us': __('United States'),
    'um': __('United States Minor Outlying Islands'),
    'uy': __('Uruguay'),
    'uz': __('Uzbekistan'),
    'vu': __('Vanuatu'),
    've': __('Venezuela, Bolivarian Republic of'),
    'vn': __('Viet Nam'),
    'vg': __('Virgin Islands, British'),
    'vi': __('Virgin Islands, U.S.'),
    'wf': __('Wallis and Futuna'),
    'eh': __('Western Sahara'),
    'ye': __('Yemen'),
    'zm': __('Zambia'),
    'zw': __('Zimbabwe'),
};

const allLabels = {
    room_type: "Room Type",
    occasion: "Occasion",
    composition: "Composition",
    leisure_trip: "Leisure Trip",
    business_trip: "Business Trip",
    fieldDescription: "Description",
    answerOption: "Option",
    emailSubject: "Email Subject",
    emailBody: "Email Body",
    thankYouText: "Thank You Text",
    submitText: "Submit button text",
    roomNumber: "Room Number",
    ...countryMap
};

module.exports = {
    topicSlugs,
    langs,
    sources,
    ratingTypes,
    allLabels
};
